// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_g60ot","markdown":"markdown_sav2t"};